// require("dotenv").config();
const { default: { getAllCodes, getLanguages } } = require("iso-639-1");

let languageCodes = {};
for (let dd of getLanguages(getAllCodes())) languageCodes[dd.code] = dd.name;

export const resources = {
  en: {
    translation: {
      // this lookup table avoids displaying raw two-letter language codes
      ...languageCodes
    }
  },
  sv: {
    translation: {
      "Sweden": "Sverige",
      "en": "engelsk",
      "sv": "svenska",
      "English": "engelsk",
      "Swedish": "svenska",
    }
  },
  de: {
    translation: {
      "In your own words": "In deinen eigenen Worten",
    }
  },
  ar: {
    translation: {
      "OK": "نعم",
      "In your own words": "بكلماتك الخاصة",
    }
  },
  zh: {
    translation: {
      "OK": "好的",
      "In your own words": "用你自己的话",
    }
  },
  ja: {
    translation: {
      "OK": "わかった",
      "In your own words": "あなたの言葉で",
    }
  },
  hi: {
    translation: {
      "OK": "ठीक है",
      "In your own words": "अपने शब्दों में",
    }
  },
  he: {
    translation: {
      "OK": "בסדר",
      "In your own words": "במילים שלך"
    }
  }
};

